"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMobileStyles = exports.getMobileStyles = void 0;
var tslib_1 = require("tslib");
var color_1 = tslib_1.__importDefault(require("color"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var constants_1 = require("./constants");
// *_MAP constants describe mapping from desktop params to be copied
var COLOR_PARAMS_MAP = {
    'main-mobileEpisodeTextColor': [
        'main-episodeTitleColor',
        'main-episodeDescriptionColor',
    ],
    'main-mobileEpisodeListBackgroundColor': ['main-episodeListBackgroundColor'],
    'main-mobileDividerOpacityColor': ['main-dividerOpacityColor'],
    'main-mobileEpisodeButtonColor': ['main-episodeButtonColor'],
};
var FONT_PARAMS_MAP = {};
var SETTINGS_MAP = {
    'main.mobileShowEpisodeImage': ['main.showEpisodeImage'],
    'main.mobileShowEpisodeDate': ['main.showEpisodeDate'],
    'main.mobileShowEpisodeDescription': ['main.showEpisodeDescription'],
    'main.mobileShowEpisodeDuration': ['main.showEpisodeDuration'],
};
function encodeColor(color, siteColors) {
    var themeName = color.themeName, value = color.value;
    var siteColor = themeName && siteColors.find(function (_a) {
        var reference = _a.reference;
        return reference === themeName;
    });
    var rgb = (0, color_1.default)(value).rgb().string();
    var opacity = (0, color_1.default)(value).alpha();
    return {
        opacity: opacity,
        rgba: rgb,
        color: siteColor
            ? {
                value: rgb,
                name: siteColor.name,
                reference: siteColor.name,
            }
            : {
                value: rgb,
            },
    };
}
function getMobileColorStyles(colors, siteColors) {
    var colorStyles = [];
    Object.keys(COLOR_PARAMS_MAP).forEach(function (mobileColorKey) {
        var desktopColorKey = (0, first_1.default)(COLOR_PARAMS_MAP[mobileColorKey]);
        if (colors[desktopColorKey]) {
            colorStyles.push({
                type: 'color',
                key: mobileColorKey,
                value: { value: encodeColor(colors[desktopColorKey], siteColors) },
            });
        }
    });
    return colorStyles;
}
function getMobileFontStyles(fonts) {
    var fontStyles = [];
    Object.keys(FONT_PARAMS_MAP).forEach(function (mobileFontKey) {
        var desktopFontKey = (0, first_1.default)(FONT_PARAMS_MAP[mobileFontKey]);
        if (fonts[desktopFontKey]) {
            fontStyles.push({
                type: 'font',
                key: mobileFontKey,
                value: { value: fonts[desktopFontKey] },
            });
        }
    });
    return fontStyles;
}
function getMobileSettingsStyles(settings) {
    var copiedSettings = (0, cloneDeep_1.default)(settings || {});
    copiedSettings.mobileSettingsCopied = true;
    Object.keys(SETTINGS_MAP).forEach(function (mobileSettingKey) {
        var desktopSettingKey = (0, first_1.default)(SETTINGS_MAP[mobileSettingKey]);
        (0, set_1.default)(copiedSettings, mobileSettingKey, (0, cloneDeep_1.default)((0, get_1.default)(copiedSettings, desktopSettingKey)));
    });
    // Hardcode LIST layout for mobile
    copiedSettings.main.mobileEpisodesLayout = constants_1.EpisodesLayout.LIST;
    return [{ type: 'font', key: 'settings', value: { value: copiedSettings } }];
}
// Creates style update actions to copy desktop settings to mobile
function getMobileStyles(styleParams, siteColors) {
    return tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], getMobileColorStyles(styleParams.colors, siteColors), true), getMobileFontStyles(styleParams.fonts), true), getMobileSettingsStyles(styleParams.fonts.settings), true);
}
exports.getMobileStyles = getMobileStyles;
function mergeMobileColorSettings(colors) {
    var mergedColors = (0, cloneDeep_1.default)(colors || {});
    Object.keys(COLOR_PARAMS_MAP).forEach(function (mobileColorKey) {
        var desktopColorKeys = COLOR_PARAMS_MAP[mobileColorKey];
        desktopColorKeys.forEach(function (desktopColorKey) {
            mergedColors[desktopColorKey] = mergedColors[mobileColorKey];
        });
    });
    return mergedColors;
}
function mergeMobileFontSettings(fonts) {
    var mergedFonts = (0, cloneDeep_1.default)(fonts || {});
    Object.keys(FONT_PARAMS_MAP).forEach(function (mobileFontKey) {
        var desktopFontKeys = FONT_PARAMS_MAP[mobileFontKey];
        desktopFontKeys.forEach(function (desktopFontKey) {
            mergedFonts[desktopFontKey] = mergedFonts[mobileFontKey];
        });
    });
    return mergedFonts;
}
function forceListLayout(settings) {
    if (settings === void 0) { settings = {}; }
    return tslib_1.__assign(tslib_1.__assign({}, settings), { main: tslib_1.__assign(tslib_1.__assign({}, (settings.main || {})), { episodesLayout: constants_1.EpisodesLayout.LIST }) });
}
function mergeMobileSettings(settings) {
    var mergedSettings = (0, cloneDeep_1.default)(settings || {});
    Object.keys(SETTINGS_MAP).forEach(function (mobileSettingPath) {
        var desktopSettingPaths = SETTINGS_MAP[mobileSettingPath];
        desktopSettingPaths.forEach(function (desktopSettingPath) {
            (0, set_1.default)(mergedSettings, desktopSettingPath, (0, get_1.default)(mergedSettings, mobileSettingPath));
        });
    });
    return forceListLayout(mergedSettings);
}
// Merges mobile settings to desktop to be used in widget
function mergeMobileStyles(styleParams) {
    var colors = styleParams.colors, fonts = styleParams.fonts, settings = styleParams.fonts.settings;
    var haveSeparateMobileSettings = (0, get_1.default)(settings, 'mobileSettingsCopied', false);
    if (haveSeparateMobileSettings) {
        return {
            colors: mergeMobileColorSettings(colors),
            fonts: tslib_1.__assign(tslib_1.__assign({}, mergeMobileFontSettings(fonts)), { settings: mergeMobileSettings(settings) }),
        };
    }
    else {
        return tslib_1.__assign(tslib_1.__assign({}, styleParams), { fonts: tslib_1.__assign(tslib_1.__assign({}, fonts), { settings: forceListLayout(settings) }) });
    }
}
exports.mergeMobileStyles = mergeMobileStyles;
//# sourceMappingURL=mobile.js.map